export type SplashScreenRefresh = 'skip' | 'clear' | 'download'

export const splashScreenRefresh = (remoteUrl: string | null | undefined, cachedUrl: string | null): SplashScreenRefresh => {
  if (!remoteUrl) {
    return cachedUrl ? 'clear' : 'skip'
  }
  return remoteUrl === cachedUrl ? 'skip' : 'download'
}
